import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=e39e3bf6&scoped=true&"
import script from "./RichTextEditor.vue?vue&type=script&lang=js&"
export * from "./RichTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=e39e3bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39e3bf6",
  null
  
)

export default component.exports